export enum MonetateKeys {
  addCategories = 'addCategories',
  setCustomVariables = 'setCustomVariables',
  setPageType = 'setPageType',
  trackData = 'trackData',
  addProductDetails = 'addProductDetails',
  addFlightSearch = 'addFlightSearch',
  addCartRows = 'addCartRows',
  addFlightReview = 'addFlightReview',
  addFlightBooking = 'addFlightBooking',
  addPurchaseRows = 'addPurchaseRows'
}

export type MonetateQueueEntry = [MonetateKeys, ...unknown[]];

declare global {
  interface Window {
    monetateQ: MonetateQueueEntry[] | undefined;
  }
}

export const monetateQKey = 'monetateQ';
export const textScript = 'text/javascript';
